import React from "react";
import HeroSection from "../sections/HeroSection/HeroSection";
import StatsSection from "../sections/StatsSection/StatsSection";
import AboutSection from "../sections/AboutSection/AboutSection";
import DiamondSection from "../sections/DiamondSection/DiamondSection";
import OurProductsSection from "../sections/OurProductsSection/OurProductsSection";
import CertificationSection from "../sections/CertificationSection/CertificationSection";
import ManufacturingProcess from "../sections/ManufacturingProcess/ManufacturingProcess";
import WhyChooseUsSection from "../sections/WhyChooseUsSection/WhyChooseUsSection";
import MobileAppSection from "../sections/MobileAppSection/MobileAppSection";

export default function Home() {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <AboutSection />
      <DiamondSection />
      <OurProductsSection />
      <CertificationSection />
      <ManufacturingProcess />
      <WhyChooseUsSection />
      <MobileAppSection />
    </div>
  );
}
